module.exports = __webpack_public_path__ + "img/collectible-card-background.5c25fe90.png";